import React, { FC, useEffect,useState } from 'react'
import styles from './ShareBlock.module.scss'
import NextImage from '../UI/nextImage/NextImage';
import facebook from '@/public/facebook.svg';
import x from '@/public/x.svg';
import link from '@/public/links.svg';
import transformDate from '@/src/assets/helpers/transformData';
import { TwitterShareButton, FacebookShareButton } from 'react-share';
import { IMeta } from '@/src/assets/interfaces/metaInterface';
import { useHydrationSafeDate } from '@/src/assets/hooks/useHydrationSafeDate';

type TShare= {
    update: string
    className?: string
    meta: IMeta
    title: string
    description: string
    logo: string
}

const ShareBlock: FC<TShare> = ({update, className, meta, title,}) => {
    const [ href, setHref ] = useState('')
    const updateDate = useHydrationSafeDate(update)

    useEffect(() => {
        setHref(window.location.href)
    }, []);

    const [copied, setCopied] = useState(false)

    const copyToClipboard = () => {
        if (window) {
            navigator.clipboard.writeText(href);
            setCopied(true)
            setTimeout(() => setCopied(false), 2000); 
        }
    };

    const showTooltip = `${styles.tooltip} ${copied ? styles['copied'] : null}`

    return (
        <div className={`${styles.share} ${className}`}>
            { updateDate && <span className={styles.update}>{`Updated on ${transformDate(updateDate!)}`}</span>}
            <div className={styles.links}>
                <div className={styles.link}>
                    <FacebookShareButton
                        url={href}
                    >
                        <NextImage 
                            width={24}
                            height={24}
                            src={facebook}
                            alt='Facebook'
                        />
                    </FacebookShareButton>
                </div>
                <div className={styles.link}>
                    <TwitterShareButton
                        url={href}
                        title={meta?.metaTitle ?? title}
                    >
                        <NextImage 
                            width={24}
                            height={24}
                            src={x}
                            alt='Twitter'
                        />
                    </TwitterShareButton>
                </div>
                
                <div className={styles.link} onClick={copyToClipboard}>
                    <NextImage 
                        width={24}
                        height={24}
                        src={link}
                        alt='Link'
                    />
                    <span className={showTooltip}>Copied!</span>
                </div>
            </div>
        </div>
    )
}

export default ShareBlock